import React from 'react';

/**
 * 리치 에디터 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const RichEditorProperties = [
  {
    group: '콘텐츠',
    properties: [
      {
        name: 'content',
        label: 'HTML 내용',
        control: 'RichTextEditor', // 리치 텍스트 에디터 컨트롤
        defaultValue: '',
        fullWidth: true
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.width',
        label: '너비',
        control: 'TextField',
        defaultValue: '100%'
      },
      {
        name: 'style.height',
        label: '높이',
        control: 'TextField',
        defaultValue: 'auto'
      },
      {
        name: 'style.minHeight',
        label: '최소 높이',
        control: 'TextField',
        defaultValue: '100px'
      },
      {
        name: 'style.margin',
        label: '외부 여백',
        control: 'TextField',
        defaultValue: '0'
      },
      {
        name: 'style.padding',
        label: '내부 여백',
        control: 'TextField',
        defaultValue: '0'
      },
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: ''
      },
      {
        name: 'style.border',
        label: '테두리',
        control: 'TextField',
        defaultValue: ''
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: ''
      }
    ]
  },
  {
    group: '고급 설정',
    properties: [
      {
        name: 'isPreview',
        label: '미리보기 모드',
        control: 'Checkbox',
        defaultValue: false
      }
    ]
  }
];

export default RichEditorProperties; 